import {mapRecordToItems} from "@/helpers/mapRecordToItems.helper";

export enum InvoiceCycleFields {
    TITLE_TEMPLATE = 'titleTemplate',
    START_DATE = 'startDate',
    INTERVAL = 'interval',
    LAST_EXECUTED_AT = 'lastExecutedAt',
    NEXT_DATE = 'nextDate',
    RECURRING_ITEMS = 'recurringItems',
    ONE_TIME_ITEMS = 'oneTimeItems',
    SERVICE_PERIOD_SHIFT = 'servicePeriodShift',
    STUDENT = 'student',
    COUNTER = 'counter',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace InvoiceCycleFields {
    type Data = {
        text: string;
        readonly?: boolean;
    }

    export const Record: Record<InvoiceCycleFields, Data> = {
        [InvoiceCycleFields.TITLE_TEMPLATE]: {
            text: 'Titel Vorlage',
            readonly: false,
        },
        [InvoiceCycleFields.START_DATE]: {
            text: 'Startdatum',
            readonly: false,
        },
        [InvoiceCycleFields.INTERVAL]: {
            text: 'Intervall',
            readonly: false,
        },
        [InvoiceCycleFields.LAST_EXECUTED_AT]: {
            text: 'Letzte Ausführung',
            readonly: true,
        },
        [InvoiceCycleFields.NEXT_DATE]: {
            text: 'Nächstes Datum',
            readonly: false,
        },
        [InvoiceCycleFields.RECURRING_ITEMS]: {
            text: 'Wiederkehrende Artikel',
            readonly: false,
        },
        [InvoiceCycleFields.ONE_TIME_ITEMS]: {
            text: 'Einmalige Artikel',
            readonly: false,
        },
        [InvoiceCycleFields.SERVICE_PERIOD_SHIFT]: {
            text: 'Relationale Verschiebung des Leistungszeitraums',
            readonly: false,
        },
        [InvoiceCycleFields.STUDENT]: {
            text: 'Schüler',
            readonly: true,
        },
        [InvoiceCycleFields.COUNTER]: {
            text: 'Zähler',
            readonly: true,
        },
        [InvoiceCycleFields.CREATED_AT]: {
            text: 'Erzeugungsdatum',
            readonly: true,
        },
        [InvoiceCycleFields.UPDATED_AT]: {
            text: 'Aktualisierungsdatum',
            readonly: true,
        },
    };

    export const Items = mapRecordToItems(Record);
}
